import { render, staticRenderFns } from "./BizInsuranceExcelCompareForm.vue?vue&type=template&id=6cfc37d7&"
import script from "./BizInsuranceExcelCompareForm.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceExcelCompareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports